export const getUserVerifyRead = () =>
  PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
